<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span
              v-if="header.value == 'startDate' || header.value =='endDate' || header.value == 'effectDate'"
            >{{ props.item[header.value] | dateFormat }}</span>
            <span v-else>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false
      },
      {
        text: "Earn Code",
        value: "earnCode",
        sortable: false
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false
      },
      {
        text: "Start Date",
        value: "startDate",
        sortable: false
      },
      {
        text: "End Date",
        value: "endDate",
        sortable: false
      },
      {
        text: "Inactive",
        value: "inactive",
        sortable: false
      },
      {
        text: "Period",
        value: "period",
        sortable: false
      },
      {
        text: "Effect Date",
        value: "effectDate",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return item.property == "ALL" && item.index == index;
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>